import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { currencyFormatter, formatDateTime } from '../../../common/utils/helpers';
import { Link } from 'react-router';
import translate from 'react-i18next/dist/commonjs/translate';
import { ResponsiveTable } from '../../../common/components/data-display';
import Table from 'antd/lib/table';

const { Column } = Table;

@translate()
export default class PendingTransactions extends Component {
  static propTypes = {
    pendingTransactions: PropTypes.array.isRequired,
    pagination: PropTypes.object.isRequired,
    onDelete: PropTypes.func.isRequired
  };

  render() {
    
    const {
      transactions,
      pagination,
      onTableChange,
      onDelete,
      t
    } = this.props;

      return <ResponsiveTable
      dataSource={transactions}
      rowKey={transaction => transaction.id}
      pagination={pagination}
      onChange={onTableChange}
    >
      <Column
        title={t('Dátum')}
        dataIndex="dateOfTransaction"
        key="date"
        render={date => formatDateTime(date)}
      />
      <Column
        title={t('Suma')}
        dataIndex="amount"
        key="amount"
        render={amount => currencyFormatter(amount)}
    />

      <Column
        title={t('Variabilný symbol')}
        dataIndex="variableSymbol"
        key="vs"
        render={vs => vs}
      />
      <Column
        title={t('Z účtu IBAN')}
        dataIndex="AccountFromNumber"
        key="ibanFrom"
        render={ibanFrom => ibanFrom}
      />
      <Column
        title={t('Na účet IBAN')}
        dataIndex="AccountToNumber"
        key="ibanTo"
        render={ibanTo => ibanTo}
      />
      <Column
        title={t('Poznámka')}
        dataIndex="comment"
        key="note"
        render={note => note}
      />
      <Column 
        title={t('Akcia')} 
        key="id" 
        dataIndex="id" 
        render={id => <Link onClick={() => onDelete(id)}>{t('Zmazať')}</Link>} />
    </ResponsiveTable>;
  }
}


// WEBPACK FOOTER //
// ./src/features/transactions/components/PendingTransactions.js